import React, { Suspense } from "react";
import { FormattedMessage,defineMessages, injectIntl } from "react-intl";
import MessagesUtil from "../../tinode/messagesUtils";
import * as MC_CONST from '../../tinode/constants'

const messages = defineMessages({
  rename_group_title: {
    id: "rename_group_title",
    defaultMessage: "Rename the group",
    description: "Rename the group",
  },
})

class RenameGroup extends React.PureComponent{
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }

    componentWillUnmount() {}
    render() {
        const { formatMessage } = this.props.intl;
        return (
            <Suspense
            fallback={
              <div className="panel-form-row">
                <FormattedMessage
                  id="loading_note"
                  defaultMessage="Loading..."
                  description="Message shown when component is loading"
                />
              </div>
            }
          >
            <div className="dialog-container custom-dialog-container">
              <div
                className="dialog-background custom-dialog-background"
                onClick={this.props.onClose}
              ></div>
              <div className="dialog-content">
                <div className="header">
                  <div className="title">{formatMessage(messages.rename_group_title)}</div>
                </div>
                <div className="content">
                    
                </div>
              </div>
            </div>
          </Suspense>
        )
    }    
}
export default injectIntl(RenameGroup);